import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Employee, employeeFields } from '@fc-core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { loadAllRequestsInOne } from '@fc-core/services/load-all-requests';

@Injectable({
  providedIn: 'root',
})
export class EmployeeApiService {
  // todo migrate all of the employee api here
  http: HttpClient = inject(HttpClient);

  getEmployeeById(id: string): Observable<Employee> {
    const params = new HttpParams().set('fields', employeeFields.join(','));
    return this.http.get<Employee>(
      environment.apiUrl + 'api/employees/' + id + '/',
      { params },
    );
  }

  loadEmployees(
    customer: string,
    archived: boolean = false,
  ): Observable<{ list: Employee[]; count: number }> {
    let httpParams = new HttpParams().set('fields', employeeFields.join(','));
    httpParams = httpParams.set('customer', customer);
    httpParams = httpParams.set('archived', archived);
    return loadAllRequestsInOne<Employee>(
      environment.apiUrl + 'api/employees/',
      this.http,
      httpParams,
    );
  }
}
